import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TabMenuItemComponent } from '../tab-menu-item/tab-menu-item.component';
import { TabItem, TabMenuStyle } from '../../tab-menu.model';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'twc-tab-menu-button-link-wrapper',
  imports: [TabMenuItemComponent, NgClass, MatButton, NgTemplateOutlet],
  templateUrl: './tab-menu-button-link-wrapper.component.html',
  styleUrls: [
    './tab-menu-button-link-wrapper.component.scss',
    '../tab-menu-link-wrapper/tab-menu-link-wrapper.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuButtonLinkWrapperComponent<T = unknown> {
  item = input.required<TabItem>();
  menuStyle = input.required<TabMenuStyle>();
  menuItemArgument = input<T>();

  itemClick = output<TabItem>();

  protected readonly TabMenuStyle = TabMenuStyle;
}
